// GENERATED FILE — do not edit. Rebuilt by scripts/generate-cms-paths.php from
// config/nav.php (via App\Support\Nav\CmsPathPrefixes) on every `vite build`.
// Add a nav row, or an entry to CmsPathPrefixes::EXTRA, to change it.

/** First path segments of every CMS/admin surface. The public analytics tracker never records these. */
export const CMS_PATH_PREFIXES: readonly string[] = [
    '/ad-studio',
    '/admin',
    '/ads',
    '/ai-logic',
    '/analytics',
    '/api',
    '/backlog',
    '/backups',
    '/campaigns',
    '/cms',
    '/collections',
    '/competitive-research',
    '/content-command',
    '/dashboard',
    '/design-studio',
    '/docs',
    '/editorial-studio',
    '/email',
    '/email-campaigns',
    '/email-templates',
    '/experiments',
    '/forms',
    '/hotel-promotion',
    '/integrations',
    '/keyword-research',
    '/lifecycle',
    '/manage-profiles',
    '/marketing-plan',
    '/my-assets',
    '/newsroom',
    '/press',
    '/printer',
    '/rally-point',
    '/routing',
    '/seo-command-center',
    '/settings',
    '/site-config',
    '/social-media',
    '/system-alerts',
    '/user-guides',
    '/users',
    '/utm-generator',
];
